export default function getNumericCharactersOnlyAndConvertToInt(value) {
  // Needs to be string since .replace() if a string method
  const numericCharactersOnly = String(value).replace(/\D/g, '');
  return parseInt(numericCharactersOnly, 10);
}
